import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {NavigationItem} from "../../../models/navigationItem";

@Component({
  selector: 'app-navigation-dialog',
  templateUrl: './navigation-dialog.component.html',
  styleUrls: ['./navigation-dialog.component.scss']
})
export class NavigationDialogComponent implements OnInit {
  public paths: NavigationItem[] = [];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<NavigationDialogComponent>) {
   this.paths = data.paths;
  }

  ngOnInit(): void {
  }

  onClose(item?: any) {
    this.dialogRef.close(item.path);
  }
}
